import React from 'react';
import Create from './pages/Create';
import Edit from './pages/Edit';
import Index from './pages/Index';
import { AppRouteProps } from '~/routes';

export default function FriendlyTypeRoutes(): readonly AppRouteProps[] {
  const routes: AppRouteProps[] = [
    {path: '/friendly-type', component: Index, isProtected: true, permissions: ['friendly_type_index']},
    {path: '/friendly-type/create', component: Create, isProtected: true, permissions: ['friendly_type_create']},
    {path: '/friendly-type/edit/:id', component: Edit, isProtected: true, permissions: ['friendly_type_edit']},
  ];

  return routes;
}
